import { formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
	labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
}
 */

function checkName(rule, value, cb) {
	const reg = /^[\u4e00-\u9fa5a-zA-Z]+$/

	if (!value) {
		cb(new Error('请输入姓名'))
	} else if (!reg.test(value)) {
		cb(new Error('姓名只支持字母与中文'))
	} else {
		cb()
	}
}
function checkAge(rule, value, cb) {
	const reg = /^((1[0-5])|[1-9])?\d$/

	if (!value) {
		cb(new Error('请输入年龄'))
	} else if (!reg.test(value)) {
		cb(new Error('请输入正确的年龄'))
	} else {
		cb()
	}
}
function checkPhone(rule, value, cb) {
	const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
	if (!value) {
		cb(new Error('请输入手机号码'))
	} else if (!reg.test(value)) {
		cb(new Error('请输入正确的手机号码'))
	} else {
		cb()
	}
}

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	let arr = []
	const info = injured.injured || ''

	arr.push({
		label: '证件类型',
		value: info && info.idType,
		selectOption: setting.idTypeList,
		key: 'idType',
		type: 'select',
		notNull: '1',
		canEdit: true,
	})
	arr.push({
		label: '证件号',
		value: info && info.idNo,
		key: 'idNo',
		type: 'text',
		notNull: '1',
		canEdit: true,
	})
	arr.push({
		label: '姓名',
		value: info && info.name,
		key: 'name',
		type: 'text',
		notNull: '1',
		canEdit: true,
		rules: [
			{
				validator: checkName,
				trigger: 'blur',
			},
			{
				max: 30,
				message: '长度不能超过30位',
				trigger: 'blur',
			},
		],
	})
	arr = arr.concat([
		{
			label: '性别',
			value: info && info.sex,
			selectOption: setting.sexList,
			key: 'sex',
			type: 'select',
			notNull: '1',
			canEdit: true,
		},
		{
			label: '年龄',
			value: info && info.age,
			symbol: '岁',
			key: 'age',
			type: 'text',
			notNull: '1',
			canEdit: true,
			rules: [
				{
					validator: checkAge,
					trigger: 'blur',
				},
			],
		},
		{
			label: '出生日期',
			value:
				info && info.birthday
					? moment(formatDate(info.birthday), 'YYYY-MM-DD')
					: '',
			key: 'birthday',
			type: 'date',
			notNull: '1',
			canEdit: true,
			allowClear: false,
		},
		{
			label: '户籍地址',
			value: info && info.censusRegisterAddress,
			key: 'censusRegisterAddress',
			type: 'text',
			notNull: '1',
			canEdit: true,
			rules: [
				{
					max: 50,
					message: '长度不能超过50位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '户籍性质',
			value: info && info.censusRegisterType,
			selectOption: setting.censusRegisterTypeList,
			key: 'censusRegisterType',
			type: 'select',
			notNull: '1',
			canEdit: true,
		},
	])
	arr.push({
		label: '伤者电话',
		value: info && info.selfPhone,
		key: 'selfPhone',
		type: 'text',
		notNull: info.phone ? '0' : '1',
		canEdit: true,
		rules: [
			{
				pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
				message: '请输入正确的手机号码',
				trigger: 'blur',
			},
		],
	})
	if (info && info.phone) {
		const phone = info.phone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '家属电话',
				value: phone[0],
				key: 'phone',
				type: 'text',
				notNull: info.selfPhone ? '0' : '1',
				canEdit: true,
				rules: [
					{
						pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
						message: '请输入正确的手机号码',
						trigger: 'blur',
					},
				],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `家属电话${index + 1}`,
					value: item,
					key: 'phone' + index,
					type: 'text',
					notNull: '0',
					canEdit: true,
					rules: [
						{
							pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
							message: '请输入正确的手机号码',
							trigger: 'blur',
						},
					],
				})
			}
		}
	} else {
		arr.push({
			label: '家属电话',
			value: '',
			key: 'phone',
			type: 'text',
			notNull: info.selfPhone ? '0' : '1',
			canEdit: true,
			rules: [
				{
					pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
					message: '请输入正确手机格式',
					trigger: 'blur',
				},
			],
		})
	}

	arr.push(
		{
			label: '伤者紧急联系人姓名',
			value: info && info.emergencyName,
			key: 'emergencyName',
			type: 'text',
			notNull: '0',
			canEdit: true,
			rules: [
				{
					pattern: /^[\u4e00-\u9fa5a-zA-Z]+$/,
					message: '姓名只支持字母与中文',
					trigger: 'blur',
				},
				{
					max: 30,
					message: '长度不能超过30位',
					trigger: 'blur',
				},
			],
		},
		{
			label: '紧急联系人与伤者关系',
			value: info && info.relationShip,
			selectOption: setting.emergencyTypeList,
			key: 'relationShip',
			type: 'select',
			notNull: '0',
			canEdit: true,
		}
	)

	if (info && info.emergencyPhone) {
		const phone = info.emergencyPhone.split(',')
		if (phone.length === 1) {
			arr.push({
				label: '紧急联系人电话',
				value: phone[0],
				key: 'emergencyPhone',
				type: 'text',
				notNull: '0',
				canEdit: true,
				rules: [
					{
						pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
						message: '请输入正确手机格式',
						trigger: 'blur',
					},
				],
			})
		} else {
			for (const [index, item] of phone.entries()) {
				arr.push({
					label: `紧急联系人电话${index + 1}`,
					value: item,
					key: 'emergencyPhone' + index,
					type: 'text',
					notNull: '0',
					canEdit: true,
					rules: [
						{
							pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
							message: '请输入正确手机格式',
							trigger: 'blur',
						},
					],
				})
			}
		}
	} else {
		arr.push({
			label: '紧急联系人电话',
			value: '',
			key: 'emergencyPhone',
			type: 'text',
			notNull: '0',
			canEdit: true,
			rules: [
				{
					pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
					message: '请输入正确手机格式',
					trigger: 'blur',
				},
			],
		})
	}
	return {
		title: '伤者信息',
		key: 'injured', // 提交时对应的字段
		children: arr,
	}
}
